/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LoggingService {

    /**
     * Get a list of all logs
     * @param logtype
     * @returns any Successful Response
     * @throws ApiError
     */
    public static provideEndpointListLoggingLogsGet(
        logtype: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/logging/logs',
            query: {
                'logtype': logtype,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
